import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiStatsSectionDTO,
  StatsSectionDTO,
} from "@lib/strapi/dtos/components/sections/statsSection.dto";
import { StatService } from "@lib/strapi/services/components/shared/stat.service";

export class StatsSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiStatsSectionDTO,
  ): Promise<StatsSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new StatsSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.eyebrow = strapiData.eyebrow;
    dto.heading = strapiData.heading;
    dto.stats = await Promise.all(
      (strapiData.stats ?? []).map(
        async (item) => await StatService.fromStrapi(locale, item),
      ),
    );
    return dto;
  }
}
